var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isFetching
        ? _c("div", [
            _c(
              "p",
              [
                _c("dc-icon", {
                  attrs: {
                    icon: "sync",
                    "fixed-width": "",
                    "no-margin": "",
                    spin: "",
                  },
                }),
                _vm._v(" " + _vm._s(_vm.title) + " "),
              ],
              1
            ),
          ])
        : _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }